import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import { reducer as user } from './modules/user';
import { reducer as home } from './modules/home';

// 合并成根reducer
const rootReducer = combineReducers({
    user: user,
    home: home
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...[thunk]));
const store = createStore(rootReducer, enhancer);

export default store;
